import script from "./TaskComments.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskComments.vue?vue&type=script&setup=true&lang=js"

import "./TaskComments.vue?vue&type=style&index=0&id=60a53c1a&lang=scss"

const __exports__ = script;

export default __exports__